import { render, staticRenderFns } from "./PaymentView.vue?vue&type=template&id=1a013ab2&scoped=true&"
import script from "./PaymentView.vue?vue&type=script&lang=js&"
export * from "./PaymentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a013ab2",
  null
  
)

export default component.exports